"use client";

import { useState } from "react";
import { NavLink, Link } from "react-router-dom";

// If your logo is in src/assets:
import logo from "../assets/logo-faef.png"; // <-- adjust path if needed

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigation = [
    { name: "Home", to: "/", end: true },
    { name: "About", to: "/about" },
    { name: "Services", to: "/services" },
    { name: "Partners", to: "/partners" },
    { name: "Contact", to: "/contact" },
  ];

  const desktopItemClass = ({ isActive }) =>
    `px-3 py-2 text-sm font-medium leading-none transition-colors ${
      isActive
        ? "text-primary-600 border-b-2 border-primary-600"
        : "text-gray-700 hover:text-primary-600"
    }`;

  const mobileItemClass = ({ isActive }) =>
    `block px-3 py-2 text-base font-medium w-full text-left transition-colors ${
      isActive
        ? "text-primary-600 bg-primary-50"
        : "text-gray-700 hover:text-primary-600 hover:bg-gray-50"
    }`;

  return (
    <nav
      className="bg-white/90 backdrop-blur-sm shadow-sm sticky top-0 z-50"
      role="navigation"
      aria-label="Main">
      <div className="container-custom">
        {/* Give the bar a bit more vertical room + inner padding to avoid clipping */}
        <div className="flex items-center justify-between h-16 md:h-18 py-1">
          {/* Brand / Logo */}
          <Link
            to="/"
            aria-label="Faef Global — Home"
            className="flex items-center gap-3 shrink-0">
            {/* LOGO IMAGE */}
            <img
              src={logo}
              alt="Faef Global"
              className="block h-9 w-auto sm:h-10 md:h-10"
              draggable="false"
              decoding="async"
            />
            {/* If you want the text next to the logo, keep this span; 
                if you want ONLY the icon, delete the span below */}
            <span className="hidden sm:inline font-bold text-xl text-primary-700 tracking-tight leading-none translate-y-[1px]">
              Faef Global
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-8 flex items-center gap-6">
              {navigation.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.to}
                  end={item.end}
                  className={desktopItemClass}>
                  {item.name}
                </NavLink>
              ))}
            </div>
          </div>

          {/* CTA (desktop) */}
          <div className="hidden lg:block">
            <Link to="/contact" className="btn-primary leading-none">
              Get Started
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen((v) => !v)}
              onKeyDown={(e) => e.key === "Escape" && setIsMenuOpen(false)}
              className="p-2 rounded-md text-gray-700 hover:text-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-200"
              aria-label="Toggle menu"
              aria-expanded={isMenuOpen}
              aria-controls="mobile-menu">
              <svg
                className="h-6 w-6"
                viewBox="0 0 24 24"
                stroke="currentColor"
                fill="none"
                aria-hidden="true">
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div id="mobile-menu" className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              {navigation.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.to}
                  end={item.end}
                  className={mobileItemClass}
                  onClick={() => setIsMenuOpen(false)}>
                  {item.name}
                </NavLink>
              ))}
              <div className="pt-2">
                <Link
                  to="/contact"
                  onClick={() => setIsMenuOpen(false)}
                  className="w-full inline-block text-center btn-primary leading-none">
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
